import React, { useState, Fragment, useEffect } from 'react'
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import ExportExcelButton from "../../components/exportExcelButton";
import { setLoading } from '../../redux/appSlice'
import { customerdetailreport, getCustomerVoidCns } from '../../services/reportservice';
import SeeMoreModal from '../../components/SeeMoreModal';

const exportColumns = [
    { label: "CN", key: "CN" },
    { label: "ConsignerAccountNo", key: "consignerAccountNo" },
    { label: "LocationName", key: "locationName" },
    { label: "ACCOUNTNO", key: "ACCOUNTNO" },
    { label: "BookingDate", key: "BookingDate" },
    { label: "RefNo", key: "RefNo" },
    { label: "Consignee", key: "Consignee" },
    { label: "ConsigneeAddress", key: "ConsigneeAddress" },
    { label: "pieces", key: "ConsigneePhoneNo" },
    { label: "weight", key: "ConsigneeEmail" },
    { label: "codAmount", key: "codAmount" },
    { label: "orderRefNo", key: "CodAmount" },
    { label: "VOID", key: "ProductDescription" },
    { label: "LOADSHEET", key: "Weight" },
    { label: "RECEIVED", key: "Origin" },
    { label: "DELIVERED", key: "Destination" },
    { label: "RTS", key: "Remarks" },
  ];


const VoidConsignmentReport = () => {
    const dispatch = useDispatch();
    const { accounts } = useSelector(state => state.appData)
    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

    const history = useHistory();

    const d = {
        month: '',
        year: '',
        account: [accounts[0]],
    };
    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);

    // window.onload = async function (e) {
    //     const reporttype = JSON.parse(sessionStorage.getItem('customerdetail'));
    //     console.log(reporttype);

    //     sessionStorage.removeItem('customerdetail');

    //     if (!reporttype) {
    //         alert('No Report Type found');
    //         return;
    //     }
    //     if (!data.Account) {
    //         alert('No Account found');
    //         return;
    //     }

    //     dispatch(setLoading({ data: true }));
    //     data.ReportType = reporttype;
    //     var rs = await customerdetailreport(data);

    //     dispatch(setLoading({ data: false }));
    //     if (rs.sts == 0) {
    //         if (rs.data.length > 0) {
    //             console.log(rs.data);
    //             setGrid(rs.data);
    //         }
    //         else {
    //             alert('No Data Found');
    //             setGrid([]);
    //         }
    //     }
    //     else {
    //         alert(rs.msg);
    //         setGrid([]);
    //     }
    // }


    useEffect(() => {
        const load = async () => {
            const voidcndata = JSON.parse(sessionStorage.getItem('voidcndata'));
            sessionStorage.removeItem('voidcndata');


            if (!voidcndata) {
                alert('No Data Found');
                return;
            }

            if (!voidcndata.accounts) {
                alert('No Data Found');
                return;
            }

            dispatch(setLoading({ data: true }));

            var rs = await getCustomerVoidCns(voidcndata);
            dispatch(setLoading({ data: false }));
            if (rs.sts == 0) {
                if (rs.data.length > 0) {
                    setGrid(rs.data);
                }
                else {
                    alert('No Data Found');
                    setGrid([]);
                }
            }
            else {
                alert(rs.msg);
                setGrid([]);
            }

            setData({ ...data});
        }
        load();
    }, [])

    return <section className="section">
        <div className="section-header">
            <h1>Void Consignments</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>

            {
                grid && grid.length > 0 &&
                <div className="row mt-3 pb-2">
                    <div className="col-12">
                        <h5>Total Records: {grid.length}</h5>
                        <div style={{ textAlign: 'right' }}>
                            {/* <ExportExcelCustomerDetail data={grid} /> */}
                               <ExportExcelButton data={grid} columns={exportColumns} fileName="ConsignmentReport"
                                />
                        </div>
                        <br />
                        <div className="table-responsive mnp-table">
                        <table className="table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>CN</th>
                                        <th>Account#</th>
                                        <th>Location Name</th>
                                        <th>Booking Date</th>
                                        {data.status == 3 && <th>Arrival Date</th>}
                                        <th>Ref No</th>
                                        <th>Consignee</th>
                                        <th>Consignee Address</th>
                                        <th>Consignee PhoneNo</th>
                                        <th>Consignee Email</th>
                                        <th>Cod Amount</th>
                                        <th>Product Description</th>
                                        <th>Weight</th>
                                        <th>Origin</th>
                                        <th>Destination</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        grid.map((x, index) =>
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {x.CN}
                                                </td>
                                                <td>{x.consignerAccountNo}</td>
                                                <td style={{ minWidth: 300 }}>
                                                    <SeeMoreModal detail={x.locationName} maxLength={120} />
                                                </td>
                                                <td>{x.BookingDate}</td>
                                                {data.status == 3 && <td>{x.ArrivalDate}</td>}
                                                <td>{x.RefNo}</td>
                                                <td>{x.Consignee}</td>
                                                <td style={{ minWidth: 300 }}>
                                                    <SeeMoreModal detail={x.ConsigneeAddress} maxLength={120} />
                                                </td>
                                                <td>{x.ConsigneePhoneNo}</td>
                                                <td>{x.ConsigneeEmail}</td>
                                                <td>{x.CodAmount}</td>
                                                <td style={{ minWidth: 300 }}>
                                                    <SeeMoreModal detail={x.ProductDescription} maxLength={120} />
                                                </td>
                                                <td>{x.Weight}</td>
                                                <td>{x.Origin}</td>
                                                <td>{x.Destination}</td>
                                                <td style={{ minWidth: 300 }}>
                                                    <SeeMoreModal detail={x.Remarks} maxLength={120} />
                                                </td>
                                            </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            }
        </div>
    </section>
}

export default VoidConsignmentReport;